<template>
	<div class="separator"></div>
</template>

<script>
export default {
	name: "Separator"
}
</script>

<style scoped>
.separator {
	border-left:1px dotted black;
	/*margin:0px 10px;*/
	height: 35px;
}
</style>
